/**
 * LegacyCheckInRedirect — `/checkin/:token` → `/guest/:token/checkin`.
 *
 * El enlace del pre-check-in existía antes que el portal y puede estar ya en
 * el correo o el WhatsApp de un huésped. Un enlace de reserva que deja de
 * abrir es un fallo de producto, no una migración limpia, así que la ruta
 * antigua se queda viva y entra en el portal por su sitio.
 *
 * `replace` para que el botón de atrás del móvil no rebote entre las dos.
 */
import React from "react";
import { Navigate, useParams } from "react-router-dom";

export default function LegacyCheckInRedirect() {
  const { token } = useParams();
  return <Navigate to={`/guest/${token}/checkin`} replace />;
}
